export default "__VITE_ASSET__XJfsh$WO__"